<style lang="scss" scoped>
  .profile {
    max-width: 1400px;

    .list-group-item li {
      font-size: 12px;
    }

    .profile-left,
    .profile-dashboard {
      background: #fff;
      padding: 20px;
      border-radius: 2px;
    }

    .profile-left {
      .avatar {
        border-radius: 100%;
        width: 150px;
        height: 150px;
        margin: 8px auto 21px auto;

        img {
          min-height: 100%;
        }
      }

      ul {
        margin-top: 13px;
        padding-left: 0;
        list-style: none;
        word-wrap: break-word;

        li {
          padding: 2px 0;
          font-size: 13px;
        }
      }
    }

    .profile-dashboard {
      h3 {
        text-align: center;
        font-size: 14px;
      }

      li {
        font-size: 12px;
      }
    }
  }
</style>

<template>
  <div>
    <h1 class="page-header">
      {{ user.first_name }} {{ user.last_name }}
    </h1>

    <div class="row profile">
      <div class="col-md-3">
        <div class="profile-left">
          <div class="avatar">
            <Avatar
              :name="user.name"
              class="thumbnail img-fluid rounded-circle avatar-lg"
              width="150"
              :url="user.gravatar"
            />
          </div>
          <ul class="success">
            <li>{{ user.first_name }} {{ user.last_name }}</li>
            <li><a :href="'mailto:' + user.email">{{ user.email }}</a></li>
            <li v-if="user.last_login_at">
              Último acesso
              <span v-b-tooltip.bottom="formatDate(user.last_login_at)">
                ({{ user.last_login_at | ago }})
              </span>
            </li>
            <li>
              <a
                :href="'/user/' + user.id + '/edit'"
                class="btn btn-box btn-block"
                title="Editar"
                style="margin-top: 5px"
              >
                Editar
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="col-md-8">
        <div class="profile-dashboard">
          <div class="row">
            <div class="col-md-2" />
            <div class="col-md-4">
              <h3>{{ __('Atividades pendentes') }}</h3>
              <ul class="list-group">
                <li
                  class="list-group-item"
                  v-for="(type, index) in types"
                  :key="index"
                >
                  <span class="badge badge-pill">{{ getTotal(type.key, false) }}</span>
                  <i :class="type.icon" /> {{ type.name }}
                </li>
              </ul>
            </div>
            <div class="col-md-4">
              <h3>{{ __('Atividades completas') }}</h3>
              <ul class="list-group">
                <li
                  class="list-group-item"
                  v-for="(type, index) in types"
                  :key="index"
                >
                  <span class="badge badge-pill">{{ getTotal(type.key, true) }}</span>
                  <i :class="type.icon" /> {{ type.name }}
                </li>
              </ul>
            </div>
            <div class="col-md-2" />
          </div>

          <hr>

          <div class="row">
            <div class="col-md-3" />
            <div class="col-md-3 text-center">
              <div class="stats-info">
                <h4>
                  {{ salesTotal }} <br>
                  <small>{{ salesTotal | pluralizeBr('Venda') }}</small>
                </h4>
              </div>
            </div>
            <div class="col-md-3 text-center">
              <div class="stats-info">
                <h4>
                  {{ salesTotalCash | currency }} <br>
                  <small>{{ __('Total em') }} {{ salesTotal | pluralizeBr('venda') }}</small>
                </h4>
              </div>
            </div>
            <div class="col-md-3" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue';
import dayjs from '../../core/dayjs';

export default {
  props: ['user', 'totals', 'types', 'salesTotal', 'salesTotalCash'],

  directives: {
    'b-tooltip': VBTooltip,
  },

  methods: {
    getTotal (type, completed) {
      const total = this.totals[completed ? 'completed' : 'pending'];

      if (total) {
        return total[type] || 0;
      }

      return 0;
    },

    formatDate (date) {
      return dayjs(date).format('LDT');
    },
  },
};
</script>
